// extracted by mini-css-extract-plugin
export default {"linkButton":"DashboardPrivacyModal_linkButton__5Xmce"};